<template>
  <article-template v-if="article" class="mb-20" :document="article">
    <template #content> </template>
    <template #sidebar>
      <article-sidebar :article="article" portal-id="portal-klubbnytt" slider-type="default" />
    </template>
  </article-template>
</template>

<script lang="ts" setup>
import { fetchArticleWithErrorHandling } from '@/utils/contentfulHelpers'

const { params } = useRouter().currentRoute.value
const slug = params.slug as string

if (!slug) {
  throw createError({
    status: 404,
    statusText: 'Not Found',
  })
}

// Fetch article data with error handling
const articleEntry = await fetchArticleWithErrorHandling(slug, `klubbnytt:${slug}`)

// Transform article data - keep image field for HeaderIntroBlock
const article = computed(() => {
  if (!articleEntry) {
    throw createError({
      status: 404,
      statusText: 'Article not found',
    })
  }
  return articleEntry
})
</script>
